export function ytEmbedUrl(url) {
  if (!url) return null;
  const m = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([A-Za-z0-9_-]{11})/
  );
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export function detectMediaType(url) {
  if (!url) return "none";
  return ytEmbedUrl(url) ? "youtube" : "image";
}
